<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator="/">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>运营数据</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="box-card">
      <div slot="header" class="flexContainer">
        <span >运营数据</span>
      </div>

      <!-- 共享搜索区 -->
      <el-form :model="queryInfo" :inline="true" size="small">
        <el-form-item label="项目名：">
          <el-input
            clearable
            v-model="queryInfo.projectKeyword"
            placeholder="项目名（模糊）"
            @clear="handleSearch"
            @keyup.enter.native="handleSearch"
            style="width: 140px"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="!myRights.isSelfOnly" label="运营师：">
          <el-select
            v-model="queryInfo.operatorId"
            placeholder="全部"
            clearable
            filterable
            @change="handleSearch"
            style="width: 100px"
          >
            <el-option
              v-for="item in operatorOptions"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="!myRights.isSelfOnly" label="现阶段负责人：">
          <el-select
            v-model="queryInfo.currentOperatorId"
            placeholder="全部"
            clearable
            filterable
            @change="handleSearch"
            style="width: 100px"
          >
            <el-option
              v-for="item in operatorOptions"
              :key="item._id"
              :label="item.name"
              :value="item._id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="店铺状态：">
          <el-select v-model="queryInfo.status" placeholder="全部" clearable @change="handleSearch" style="width: 100px">
            <el-option label="待运营" value="待运营"></el-option>
            <el-option label="运营中" value="运营中"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌：">
          <el-select v-model="queryInfo.brand" placeholder="全部" clearable
            @change="handleSearch" style="width: 100px">
            <el-option v-for="item in brandList" :key="item" :label="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期：">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="handleSearch"
            style="width: 260px"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>

      <!-- tabs -->
      <el-tabs v-model="activeTab">
        <el-tab-pane label="美团" name="meituan">
          <meituan-data-tab :query="appliedQuery" @my-rights="onMyRights"></meituan-data-tab>
        </el-tab-pane>
        <el-tab-pane label="淘宝闪购" name="taobao">
          <taobao-data-tab :query="appliedQuery" @my-rights="onMyRights"></taobao-data-tab>
        </el-tab-pane>
        <el-tab-pane label="京东" name="jd">
          <jd-data-tab :query="appliedQuery" @my-rights="onMyRights"></jd-data-tab>
        </el-tab-pane>
      </el-tabs>
    </el-card>
  </div>
</template>

<script>
import MeituanDataTab from './data/MeituanDataTab.vue'
import TaobaoDataTab from './data/TaobaoDataTab.vue'
import JdDataTab from './data/JdDataTab.vue'
import { brandList } from '@/utility/staticData'

export default {
  components: { MeituanDataTab, TaobaoDataTab, JdDataTab },
  data () {
    return {
      activeTab: 'meituan',
      brandList,
      queryInfo: {
        projectKeyword: '',
        operatorId: '',
        currentOperatorId: '',
        status: '',
        brand: ''
      },
      dateRange: [],
      appliedQuery: {}, // 下发给子组件的查询对象（每次新引用，触发子组件 watch）
      yunyingList: [],
      // 当前用户权限标记（由各平台 tab 从列表接口上抛，控制筛选区显隐；默认不受限）
      myRights: { isSelfOnly: false },
      pickerOptions: {
        shortcuts: [
          {
            text: '最近7天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近30天',
            onClick (picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      }
    }
  },
  computed: {
    // 与店铺管理页 Dianpu.vue 同口径：仅运营师类岗位可选
    operatorOptions () {
      return this.yunyingList.filter(e => /运营师|运营主管|建店专员/.test(e.job))
    }
  },
  created () {
    this.setDefaultDateRange()
    this.getYunyingList()
    // 初始查询
    this.$nextTick(() => this.handleSearch())
  },
  methods: {
    setDefaultDateRange () {
      // 默认查看前天到昨天的数据（日报数据 T+1 采集，当天常无数据）
      const day = 3600 * 1000 * 24
      const end = new Date()
      end.setTime(end.getTime() - day)
      const start = new Date()
      start.setTime(start.getTime() - day * 2)
      this.dateRange = [this.fmtDate(start), this.fmtDate(end)]
    },
    fmtDate (d) {
      const y = d.getFullYear()
      const m = String(d.getMonth() + 1).padStart(2, '0')
      const day = String(d.getDate()).padStart(2, '0')
      return `${y}-${m}-${day}`
    },
    async getYunyingList () {
      try {
        const { data: res } = await this.$http.get('yunying/employees/list')
        if (res.meta.status !== 200) {
          console.error('获取运营师列表失败:', res.meta.msg)
          return
        }
        this.yunyingList = res.data || []
      } catch (e) {
        console.error('获取运营师列表失败:', e)
      }
    },
    // 组装下发给子组件的 query（每次新对象，触发子组件 watch）
    buildQuery () {
      return {
        projectKeyword: this.queryInfo.projectKeyword || '',
        operatorId: this.queryInfo.operatorId || '',
        currentOperatorId: this.queryInfo.currentOperatorId || '',
        status: this.queryInfo.status || '',
        brand: this.queryInfo.brand || '',
        startDate: (this.dateRange && this.dateRange[0]) || '',
        endDate: (this.dateRange && this.dateRange[1]) || ''
      }
    },
    handleSearch () {
      this.appliedQuery = this.buildQuery()
    },
    // 各平台 tab 上抛的权限标记（三个 tab 响应值一致，重复触发无碍）
    onMyRights (v) {
      this.myRights = v || { isSelfOnly: false }
    },
    handleReset () {
      this.queryInfo = { projectKeyword: '', operatorId: '', currentOperatorId: '', status: '', brand: '' }
      this.setDefaultDateRange()
      this.handleSearch()
    }
  }
}
</script>

<style lang="less" scoped>
.box-card {
  margin-top: 15px;
}
</style>
